export const POPULAR_PLACE_LIST_ACTION = "POPULAR_PLACE_LIST_ACTION";
export const POPULAR_PLACE_LIST_SUCCESS = "POPULAR_PLACE_LIST_SUCCESS";
export const POPULAR_PLACE_LIST_FAIL = "POPULAR_PLACE_LIST_FAIL";
export const POPULAR_PLACE_DETAIL_ACTION = "POPULAR_PLACE_DETAIL_ACTION";
export const POPULAR_PLACE_DETAIL_SUCCESS = "POPULAR_PLACE_DETAIL_SUCCESS";
export const POPULAR_PLACE_DETAIL_FAIL = "POPULAR_PLACE_DETAIL_FAIL";
export const POPULAR_PLACE_DETAIL_UPDATE_ACTION = "POPULAR_PLACE_DETAIL_UPDATE_ACTION";
export const POPULAR_PLACE_DETAIL_CREATE_ACTION = "POPULAR_PLACE_DETAIL_CREATE_ACTION";